<template>
  <div>
    <div class="review__contact">
      <el-row :gutter="30" v-if="contactName || contactEmail || contactPhone">
        <el-col :sm="16">
          <ul class="contact__meta">
            <li class="contact__name">{{ contactName }}</li>
            <li class="contact__email">{{ contactEmail }}</li>
            <li class="contact__phone">{{ contactPhone }}</li>
          </ul>
        </el-col>
        <el-col :sm="8">
          <span class="contact__date">{{ moment().format(dateFormat) }}</span>
        </el-col>
      </el-row>
    </div>
    <div class="review__assets" v-for="group in formattedAssets" :key="group.id">
      <el-row type="flex" align="middle">
        <el-col :span="16">
          <span class="asset__family">{{ group.familyDisplay }}</span>
        </el-col>
        <el-col :span="8">
          <span class="asset__count text-align-right">{{ group.selected.length }} {{ $t('outboxReviewAssets') }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import constants from '@/constants';
  import outbox from '@/components/outbox';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'OutboxReviewInfo',
    data() {
      return {
        dateFormat: constants.DATE_FORMAT
      };
    },
    computed: {
      ...mapState(outbox.store.namespace, [
        'contactName',
        'contactEmail',
        'contactPhone',
        'assets'
      ]),
      ...mapGetters(outbox.store.namespace, [
        'formattedAssets'
      ]),
    },
    methods: {
      moment
    }
  }

  //////////
</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .review {

    &__contact {
      display: block;
      width: 100%;
      margin-bottom: 16px;
    }

    &__assets {
      display: block;
      width: 100%;
      padding: 8px 0;
      border-bottom: 1px solid gray;
    }
  }

  .asset {

    &__family,
    &__count {
      display: block;
      width: 100%;

    }

    &__family {
      font-weight: 700;
    }
  }

  .contact {

    &__meta,
    &__date {
      display: block;
      width: 100%;
    }

    &__meta {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__name {
      font-weight: 700;
    }

    &__date {
      font-size: 12px;

      @include res(sm) {
        text-align: right;
      }
    }
  }

</style>
